import { object, string, date } from 'yup'
import { sub, isPast } from 'date-fns'

export interface ApplicationIdSearchValues {
  applicationId: string
  dob: Date
}

export enum ApplicationIdKeys {
  APPLICATION_ID = 'applicationId',
  DOB = 'dob',
}

export const ApplicationIdSearchLabels = {
  [ApplicationIdKeys.APPLICATION_ID]: 'CLEAR Application ID',
  [ApplicationIdKeys.DOB]: 'Date of Birth',
}

export const applicationIdSearchSchema = object().shape({
  applicationId: string()
    .trim()
    .required('Please enter Application ID.')
    .matches(
      /^[0123456789ABCDEFGHJKMNPQRSTVWXYZ]{4}-[0123456789ABCDEFGHJKMNPQRSTVWXYZ]{4}$/,
      'Invalid Application ID.'
    ),
  dob: date()
    .required()
    .test('is-past', 'Date must be in the past.', (value) =>
      isPast(value || new Date())
    )
    .max(
      sub(new Date(), { years: 5 }),
      'Applicants must be at least 5 years or older.'
    )
    .min(
      sub(new Date(), { years: 115 }),
      'Applicants must be less than 115 years old.'
    )
    .typeError('Invalid Date.'),
})
